import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, } from '@mui/material';
import { DialogCloseButton } from '../DialogCloseButton';
export const DIALOG_TITLE_ID = 'dialog-title';
export const DialogTitle = ({ children, onClose, closeButtonSx = {}, titleSx = {}, ...rest }) => {
    return (_jsxs(Typography, { variant: "h3", sx: {
            display: 'flex',
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            pb: 1.5,
            ...titleSx,
        }, component: "h1", "aria-label": typeof children === 'string' ? children : undefined, id: DIALOG_TITLE_ID, ...rest, children: [children, onClose ? (_jsx(DialogCloseButton, { onClick: onClose, sx: closeButtonSx })) : null] }));
};
